import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallback = () => {
  const [status, setStatus] = useState('Processing...');
  const navigate = useNavigate();

  useEffect(() => {
    // Check URL hash and search params for the type of auth callback
    const hash = window.location.hash;
    const searchParams = new URLSearchParams(window.location.search);
    const typeFromSearch = searchParams.get('type');

    // Parse hash params (Supabase puts tokens in the hash fragment)
    const hashParams = new URLSearchParams(hash.replace('#', ''));
    const typeFromHash = hashParams.get('type');

    const callbackType = typeFromSearch || typeFromHash;

    if (callbackType === 'recovery') {
      // Password recovery flow — let Supabase exchange the token, then go to reset page
      setStatus('Verifying reset link...');
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (session) {
          navigate('/reset-password');
        } else {
          // Wait for the auth state change event to fire
          const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'PASSWORD_RECOVERY' || (event === 'SIGNED_IN' && session)) {
              subscription.unsubscribe();
              navigate('/reset-password');
            }
          });
          // Timeout fallback
          setTimeout(() => {
            subscription.unsubscribe();
            navigate('/reset-password');
          }, 3000);
        }
      });
    } else {
      // Email confirmation / signup flow
      setStatus('Email verified! Redirecting...');
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (session) {
          setTimeout(() => navigate('/dashboard'), 1500);
        } else {
          const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'SIGNED_IN' && session) {
              subscription.unsubscribe();
              navigate('/dashboard');
            }
          });
          setTimeout(() => {
            subscription.unsubscribe();
            setStatus('Verification complete. Please sign in.');
            setTimeout(() => navigate('/login'), 1500);
          }, 3000);
        }
      });
    }
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--light-gray)' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: '#d1fae5',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 2rem'
        }}>
          <span style={{ fontSize: '2.5rem' }}>✓</span>
        </div>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem' }}>
          {status.includes('reset') || status.includes('Verifying') ? 'Reset Link Verified' : 'Email Verified!'}
        </h1>
        <p style={{ color: 'var(--gray)', fontSize: '1.1rem' }}>
          {status}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
